import { Injectable, Injector } from '@angular/core';
import { DataService } from './data.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Store } from '@ngrx/store';
//Languages
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';

// Lib libphonenumber
import { PhoneNumberUtil } from 'google-libphonenumber';
import { CountryISO } from 'ngx-intl-tel-input';

// Moment
import moment from 'moment-timezone';
export const TEMPLATE_BULK_MASSIVE_PATH = '/assets/resources/excel/Invitaciones masivas.xlsx';
@Injectable()
export class CommonService extends DataService {
  private phoneUtil = PhoneNumberUtil.getInstance();

  constructor(private http: HttpClient, protected injector: Injector, protected store: Store<any>) {
    super(injector, store);
  }

  getDataDashboard() {
    return this.http
      .get(`${environment.apiUrl}/dashboard/getdata`)
      .toPromise()
      .then((res) => {
        console.log('ress: ', res);
      })
      .catch((err) => {
        console.log('errr: ', err);
        Promise.reject(err);
      });
  }

  triggerResize() {
    setTimeout(function () {
      var resizeEvent = window.document.createEvent('UIEvents');
      resizeEvent.initEvent('resize', true, false);
      window.dispatchEvent(resizeEvent);
    }, 500);
  }

  validPhoneExceptions(control) {
    // Colombian
    if (control.status == 'INVALID' && control.value && control.value.countryCode == 'CO' && control.value.nationalNumber) {
      if (control.value.nationalNumber.length == 11 && control.value.nationalNumber.slice(0, 3) == '324') {
        control.setErrors(null);
      }
    }
    return control;
  }

  getLanguagesList(): string[] {
    return [localeEs, localeEn].map((locale) => locale[0]) as string[];
  }

  getCountryISOFromPhoneNumber(phoneNumber: string): CountryISO | null {
    try {
      const number = this.phoneUtil.parse(phoneNumber);
      const regionCode = this.phoneUtil.getRegionCodeForNumber(number);
      return regionCode;
    } catch (error) {
      return null;
    }
  }

  getNationalNumber(phoneNumber: string): string | null {
    try {
      const number = this.phoneUtil.parse(phoneNumber);
      return this.phoneUtil.getNationalSignificantNumber(number);
    } catch (error) {
      return null;
    }
  }

  /**
   * Converts a country ISO code (e.g., 'PA', 'CO') to CountryISO enum value.
   * Falls back to Panama if the code is invalid or not found.
   * @param isoCode - The ISO 3166-1 alpha-2 country code
   * @returns CountryISO enum value
   */
  getCountryISOFromCode(isoCode: string): CountryISO {
    if (!isoCode) return CountryISO.Panama;
    const normalizedCode = isoCode.toLowerCase();
    const isValidCountryISO = Object.values(CountryISO).includes(normalizedCode as CountryISO);
    return isValidCountryISO ? (normalizedCode as CountryISO) : CountryISO.Panama;
  }

  getStartDate(date: string) {
    return moment(date).startOf('day').format('YYYY-MM-DD');
  }

  getEndDate(date: string) {
    return moment(date).startOf('day').format('YYYY-MM-DD');
  }

  downloadTemplateBulkMassive() {
    const filePath = TEMPLATE_BULK_MASSIVE_PATH;
    return this.http.get(filePath, { responseType: 'blob' });
  }
}
